import { useQuery } from '@tanstack/react-query';
import { api_host, api_auth } from '../common/globals/constants';
import { getApiKeys } from '../utils/fns/get-api-keys';
import { format } from 'date-fns';

const fetchSentimientoReviews = async (user, token, filters, pageParam = 1) => {
  const params = new URLSearchParams({
    user,
    key: api_auth,
    token,
    page: pageParam,
  });

  if (filters?.selectedApp && filters.selectedApp !== '') {
    params.append('app', filters.selectedApp);
  }
  if (filters?.selectedPlatform && filters.selectedPlatform !== '') {
    params.append('store', filters.selectedPlatform);
  }
  if (filters?.selectedVersion && filters.selectedVersion !== '') {
    params.append('version', filters.selectedVersion);
  }

  if (filters?.selectedPeriod) {
    const time = filters.selectedPeriod.period || 'w';
    params.append('t', time);
    
    if (time === 'c' && filters.selectedPeriod.statePeriod) {
      params.append('fechaInicio', format(new Date(filters.selectedPeriod.statePeriod.startDate), 'yyyy-MM-dd'));
      params.append('fechaTermino', format(new Date(filters.selectedPeriod.statePeriod.endDate), 'yyyy-MM-dd'));
    }
  } else {
    params.append('t', 'w');
  }

  const url = `${api_host}/reporte/online/indicadores/getSentimientoReviews/?${params.toString()}`;
  
  const response = await fetch(url);
  if (!response.ok) {
    const error = new Error(`HTTP ${response.status}`);
    error.status = response.status;
    throw error;
  }
  return response.json();
};

export const useSentimientoReviews = (filters, page, options = {}) => {
  const { user, token } = getApiKeys();

  return useQuery({
    queryKey: ['sentimientoReviews', user, filters, page],
    queryFn: () => fetchSentimientoReviews(user, token, filters, page),
    enabled: !!user && !!token,
    staleTime: 1000 * 60 * 5, //5m
    ...options
  });
};
